module.exports = __webpack_public_path__ + "img/Fabella_closed.88852aee.png";